<tn-dialog-shell testId="session-expiring" [title]="options.title | translate">
  <div id="confirm-msg">
    <div class="message-content">
      <span [innerHTML]="options.message | translate"></span>

      @let preferencesHint = changeTimeoutHint | translate | splitTag;
      <p>
        {{ preferencesHint.before }}<button
          class="preferences-link"
          tnTestIdType="button"
          [tnTestId]="'open-preferences'"
          (click)="openPreferences()"
        >{{ preferencesHint.inner }}</button>{{ preferencesHint.after }}
      </p>
    </div>
  </div>

  <div tnDialogAction>
    <tn-button
      color="primary"
      class="submit-button"
      testId="session-expiring-extend-confirm"
      [label]="options.buttonText | translate"
      (onClick)="extendSession()"
    ></tn-button>
  </div>
</tn-dialog-shell>
